export function groupTagStyle(id) {
	if (!id) return {};
	const hue = Math.round((Number(id) * 137.5) % 360);
	return { color: `hsl(${hue}, 62%, 28%)`, borderColor: `hsl(${hue}, 58%, 66%)`, backgroundColor: `hsl(${hue}, 72%, 89%)`, boxShadow: `inset 4px 0 hsl(${hue}, 65%, 48%)` };
}
